import { useEffect } from "react";

/**
 * Custom hook to set the document title for each page
 * @param title - The title to set for the current page
 * @param baseName - The base name to append to the title (default: "Lilly ExploR&D")
 */
export const useDocumentTitle = (
  title: string,
  baseName: string = "Lilly ExploR&D",
) => {
  useEffect(() => {
    const previousTitle = document.title;

    // Set the new title
    document.title = title ? `${title} | ${baseName}` : baseName;

    // Cleanup function to restore previous title if needed
    return () => {
      document.title = previousTitle;
    };
  }, [title, baseName]);
};
